import React from 'react';
import type { SwampEventSummary } from '../types';
import { TrophyCard } from './TrophyCard';

interface TrophyGridProps {
   events: SwampEventSummary[];
}

export function TrophyGrid({ events }: TrophyGridProps) {
   return (
      <div className="swamp-trophy-grid">
         {events.map((event) => (
            <TrophyCard key={event.id} event={event} />
         ))}
      </div>
   );
}
